export const getRessellers = (state) =>
  state.ressellers;



// WEBPACK FOOTER //
// ./src/store/selectors/ressellers.js